export const shortageEmailAllocatedText =
  "There are not enough emails in the file to allocate all days according to the preset selected";
export const overlimitEmailAllocatedText =
  "There are too many e-mails in the file to allocate all days according to the selected setting, assign the remaining e-mails manually or change the duration of the job";
